import React, { useState, useEffect, useMemo } from 'react'
import Card from './Card'
import './SelectLeague.css'
import { useNavigate } from 'react-router-dom'

const SelectLeague = () => {
	console.log('inside SelectLeague.js')

	const [isLoading, setIsLoading] = useState(false)
	const [leaguesNoDuplicates, setLeaguesNoDuplicates] = useState([])
	const [dropdownTournaments, setDropdownTournaments] = useState([])
	const [error, setError] = useState()

	const navigate = useNavigate()

	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/current',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLeaguesNoDuplicates(
					responseData.currentLeaguesSortedNoDuplicates || [],
				)
				setDropdownTournaments(responseData.dropdownTournaments || [])
			} catch (err) {
				setError(err.message)
			} finally {
				setIsLoading(false)
			}
		}
		sendRequest()
	}, [])

	// Build a single list of dropdown options
	const dropdownItems = useMemo(() => {
		const items = []

		// internal leagues
		for (const league of leaguesNoDuplicates) {
			if (!league?._id || !league?.leagueName) continue
			items.push({
				label: league.leagueName,
				value: `league:${league._id}`,
			})
		}

		// external tournaments
		for (const t of dropdownTournaments) {
			if (!t?.tournamentName || !t?.tournamentLink) continue
			items.push({
				label: t.tournamentName,
				value: `external:${t.tournamentLink}`,
			})
		}

		// optional: alphabetical overall
		//items.sort((a, b) => a.label.localeCompare(b.label))

		return items
	}, [leaguesNoDuplicates, dropdownTournaments])

	const handleChange = (e) => {
		const value = e.target.value
		if (!value || value === 'default') return

		if (value === 'previous') {
			navigate('/league/previousLeagues')
			return
		}

		if (value.startsWith('league:')) {
			const leagueId = value.replace('league:', '')
			navigate(`/league/${leagueId}`)
			return
		}

		if (value.startsWith('external:')) {
			const url = value.replace('external:', '')
			window.open(url, '_blank', 'noopener,noreferrer')
			return
		}
	}

	return (
		<React.Fragment>
			<Card>
				{error && (
					<div style={{ padding: 10 }}>
						<strong>Error:</strong> {error}
					</div>
				)}

				{!isLoading && (
					<form className='form-control-lg'>
						<select
							className='selector my-1 mr-sm-2 selectLeagueDropdown'
							onChange={handleChange}
							defaultValue='default'
						>
							<option value='default'>Select League or Tournament....</option>

							{dropdownItems.map((item) => (
								<option value={item.value} key={item.value}>
									{item.label}
								</option>
							))}

							<option value='previous' style={{ background: '#edcb37' }}>
								*Previous Tournaments*
							</option>
						</select>
					</form>
				)}
			</Card>
		</React.Fragment>
	)
}

export default SelectLeague

/* //This is the white bar that goes the width of the screen
import React, { useState, useEffect } from 'react'
import Card from './Card'
import './SelectLeague.css'
import { useNavigate } from 'react-router-dom'
//import LeagueDatabaseTable from '../LeagueDatabaseTable'

const SelectLeague = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedLeagues, setLoadedLeagues] = useState()
	const [leaguesNoDuplicates, setLeaguesNoDuplicates] = useState()
	const [error, setError] = useState()
	let selectedLeague

	//Call backend to get all the current leagues for our dropdown
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/current',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedLeagues(responseData.currentLeagues)
				setLeaguesNoDuplicates(responseData.currentLeaguesSortedNoDuplicates)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [setLoadedLeagues, setLeaguesNoDuplicates])

	let leagueArray, leaguesNoDuplicatesArray

	//
	//
	//
	if (leaguesNoDuplicates && !isLoading) {
		leaguesNoDuplicatesArray = []
		leaguesNoDuplicates.forEach((league) => {
			const leagueDisplay = league.leagueName
			leaguesNoDuplicatesArray.push(leagueDisplay)
		})
	}

	let navigate = useNavigate()

	const handleChange = (e) => {
		if (e.target.value === '*Previous Tournaments*') {
			navigate('/league/previousLeagues')
		} else if (e.target.value !== 'Select League or Tournament....') {
			e.preventDefault()
			const selectedValue = e.target.value
			selectedLeague = leaguesNoDuplicates[selectedValue]
			const leagueId = selectedLeague._id
			navigate(`/league/${leagueId}`) //< - - This changes the url
		}
	}

	return (
		<React.Fragment>
			<Card>
				{!isLoading && leaguesNoDuplicates && (
					<form className='form-control-lg'>
						<select
							className='selector my-1 mr-sm-2 selectLeagueDropdown'
							onChange={handleChange}
						>
							<option defaultValue>Select League or Tournament....</option>
							{leaguesNoDuplicatesArray.map((league, i) => (
								<option value={i} key={i}>
									{league}
								</option>
							))}
							<option style={{ background: '#edcb37' }}>
								*Previous Tournaments*
							</option>
						</select>
					</form>
				)}
			</Card>
		</React.Fragment>
	)
}

export default SelectLeague
 */
